export const CHALLENGE_DIALOG_LOADER_ID = 'challenge-dialog';
